module.exports = __webpack_public_path__ + "static/media/18ECA4.5e4731aa.jpg";